<template>
  <v-container class="px-0">
    <v-row class="mt-5 mb-2 px-3">
      <h3>Usuários cadastrados</h3>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        small
        height="30px"
        color="primary"
        @click="selectItem(null, 'addItem')"
        v-if="permissao.adduser"
      >Adicionar usuário</v-btn>
      <v-tooltip v-else center bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          outlined
          color="rgb(151 151 151 / 58%)"
          depressed
          v-bind="attrs"
          v-on="on"
          >Adicionar usuário</v-btn>
        </template>
        <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
          Você não possui permissão para executar esta ação.
        </span>
      </v-tooltip>
    </v-row>
    <v-row class="px-3">
      <v-col class="col-sm-3 px-0">
        <v-text-field
          dense
          outlined
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Busca"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="col-sm-4 px-0">
            <v-select
              v-model="prestador"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col class="col-sm-1 text-right mr-0">
            <v-btn
              small
              height="30px"
              depressed
              color="primary"
              @click="filterList(prestador, grupoEconomico, search)"
              >Filtrar</v-btn
            >
          </v-col>
        </v-row>
          <v-spacer></v-spacer>
          <v-col class="px-0 text-right ">
            <v-btn
              color="primary"
              class="p-0"
              text
              @click="downloadFile(prestador, search, grupoEconomico, true)"
            >
              <v-icon small class="pr-2">fa-download</v-icon>
              Exportar resultado
            </v-btn>
          </v-col>
        
      <v-card-text class="px-0">
        <v-data-table
          :headers="headers"
          :items="usersList"
          :search="search"
          dense
        >
          <template v-slot:item="props">
            <tr>
              <td class="text-left pa-1">
                <v-icon color="green" small v-if="props.item.IsActive"
                  >fa-check-circle</v-icon
                >
                <v-icon small v-if="!props.item.IsActive">fa-ban</v-icon>
                {{ props.item.Nome }}
              </td>
              <td class="text-left pa-1">{{ props.item.UserName }}</td>
              <td class="text-left pa-1">{{ props.item.Email }}</td>
              <td
                class="text-center pa-1"
                v-if="
                  permissao.updateuser ||
                  permissao.resetpassword ||
                  permissao.changestatususer
                "
              >
                <v-btn
                  small
                  color="primary"
                  icon
                  @click="selectItem(props.item, 'edit')"
                  v-if="permissao.updateuser"
                >
                  <v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  icon
                  @click="selectItem(props.item, 'resetPwd')"
                  v-if="shouldShowResetPasswordButton(props.item)"
                >
                  <v-icon small>fa-lock</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  icon
                  @click="selectItem(props.item, 'toggleStatus')"
                  v-if="permissao.changestatususer"
                >
                  <v-icon small v-if="props.item.IsActive">fa-ban</v-icon>
                  <v-icon small v-else>fa-check-circle</v-icon>
                </v-btn>
                <v-btn
                  small
                  icon
                  @click="selectItem(props.item, 'edit')"
                  v-if="shouldShowMFAActionButton"
                  :color="props.item.IsMFARequired ? 'primary' : 'grey'"
                >
                  <v-icon small>fa-shield-alt</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    <!-- <Footer /> -->
  </v-container>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      search: "",
      headers: [
        { text: "Nome", align: "start", value: "Nome" },
        { text: "Usuário", value: "UserName" },
        { text: "Email", value: "Email" },
        { text: "Ações", value: "actions" },
      ],
      prestador: null,
      prestadoresFilter: [],
    };
  },
  watch: {
    prestadores: {
      deep: true,
      handler() {
        this.prestadoresFilter = Array.from(this.prestadores);
        this.prestadoresFilter.unshift({ id: null, prest_nome: "Selecione" });
      },
    },
  },
  mounted() {
    this.prestadoresFilter = Array.from(this.prestadores);
    // if (this.prestadoresFilter.length==1) {
    //   this.prestador = this.prestadoresFilter[0].id
    //   this.filterList(this.prestador, this.grupoEconomico, this.search)
    // } else {
      this.prestadoresFilter.unshift({ id: null, prest_nome: "Selecione" });
    // }
  },
  computed: {
    shouldShowMFAActionButton() {
      return this.parametrizacoes.PLT_MULTIPLO_FATOR_DE_AUTENTICACAO_HABILITADO ?? false;
    },
  },
  props: {
    filterList: Function,
    grupoEconomico: Number,
    usersList: Array,
    permissao: Object,
    prestadores: Array,
    selectItem: Function,
    parametrizacoes: Object,
  },

  methods: {
    downloadFile(PrestadorId, SearchText, grupo_economico){
      this.$store.commit("showLoader", { circle: true }, {root: true});
      let modulo = "Portal"
      let acao = "getuserscsv"
      let Payload = {PrestadorId, SearchText, grupo_economico}
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: ()=> setTimeout(()=>{this.$store.commit('hideLoader')}, 200), modulo }, {root:true})
    },
    shouldShowResetPasswordButton(usuario) {
      if( usuario.IsPasswordLoginDisabled ) {
        return false;
      }

      return this.permissao.resetpassword;
    },
  }
};
</script>

<style>
</style>
